export enum LoanOptions {
  LD = 'Larga Duración',
  CP = 'CarPool',
  W = 'Bodas'
}

export enum LoanReasons {
  MALFUNCTION_MAINTENANCE_ACCIDENT = 'Avería/Mantenimiento/Siniestro del vehículo',
  BUSINESS_TRIP = 'Viaje de trabajo',
  SUPPLIER_VISIT = 'Visita proveedor',
  OTHERS = 'Otros'
}

export enum LoanReasonsCarPool {
  MEETING = 'Reunión',
  OTHERS = 'Otros'
}
